module.exports = __webpack_public_path__ + "static/media/15423183516891950742167 - Citizen Datasteward.f2c48908.jpg";